var shvenergy = shvenergy || {};

shvenergy.naturallanguageform = (function ($) {
    "use strict";

    var optionsApi = "/api/naturallanguageform/options/";

    function resetButtonsAndLists(index, form) {
        var but;
        var butText;
        var list;
        var dropDowns = $(form).find(".nlf-span");
				var ctaButton = $(form).find(".nlf-cta");
				var errorText = $(form).find(".natural-language-form__error");

        for (var i = index; i < dropDowns.length; i++) {
            but = $(dropDowns[i]).find("button");
            butText = but.find(".sentense-part");
            butText.text(but.data("defaulttext"));
            but.addClass("disabled");

            list = $(dropDowns[i]).find(".nlf-list");
            list.empty();
        }

        if (dropDowns.length === index) {
						ctaButton.addClass("is-active");
						errorText.addClass("hide");
        } else {
						ctaButton.removeClass("is-active");
						errorText.removeClass("hide");
        }
    }

	function populateDropDown(index, id, form) {
        var url = optionsApi + id;
        var dropDowns = $(form).find(".nlf-span");

		$.getJSON(url, function (data) {
			var but = $(dropDowns[index + 1]).find(".nlf-button");
			var list = $(dropDowns[index + 1]).find(".nlf-list");
			but.removeClass("disabled");
			list.empty();

			$.each(data.Options, function () {
				var opt = $("<input />", {
					'type': 'radio',
					'name': id,
					'value': $(this)[0].Id,
					'class': 'nlf-radio',
					'data-index': index + 1,
					'data-text': $(this)[0].Title,
					'data-url': $(this)[0].LandingPageUrl,
					'data-target': $(this)[0].OpenLinkInNewWindow
					//'text': $(this)[0].Title
				});

				var label = $("<label />", {
					'text': $(this)[0].Title
				});
				var li = $("<li />");
				opt.prependTo(label);
				label.appendTo(li);
				li.appendTo(list);
			});
		});
	}

	function hideLists() {
		$(".nlf-list").removeClass("is-active");
	}

	function init() {

		$(".nlf-button").on("click", function () {

			var self = $(this);
			self.removeClass("pulse");

			hideLists();

			if (self.hasClass("disabled")) {
				self.addClass("shake");
				setTimeout(function () {
					self.removeClass("shake");
				}, 1000);

				return;
			}

			const clicked = $(this);
			if (clicked.attr("aria-expanded") === "false")
				clicked.attr("aria-expanded", "true");
			else
				clicked.attr("aria-expanded", "false");

			const next = clicked.next("ul");
			$(".nlf-list").not(next).removeClass("is-active");
			clicked.next("ul").toggleClass("is-active");
		});

		$(document).on("click", ".nlf-radio", function () {

            var self = $(this);
            var form = self.parents("form");
			var id = self.val();
			var text = self.data("text");
			var index = self.data("index");
			var url = self.data("url");
			var dataTarget = self.data("target");
			var parent = self.parents("ul");
            var activeIndex = parseInt(parent.data("index") + 1);

            form.find("button[data-index='" + activeIndex + "']").addClass("pulse");

            var ctaButton = $(form).find(".nlf-cta");

			if (shvenergy.cookies.hasCookieCategoryConsent("_shvenergy_nlf_option")) {
				shvenergy.cookies.setCookie("_shvenergy_nlf_option", id, 1);
			}
			shvenergy.tracking.trackEvent('Natural Language Form', 'option clicked', text);

            var button = self.parents(".nlf-span").find(".nlf-button");
            var buttonText = button.find(".sentense-part");
			const widthOld = button.width();

			//To animate the button, we need to know the width of the button with the new text
			//So we clone the button...
			var clone = button.clone();
			//Set the text...
			clone.text(text);
			//Add class to it so we can find it and remove it safely later...
			clone.addClass("clone");

			//Then append it to the dom so we can measure the final width
			self.parents(".nlf-span").append(clone);
			//Get the cloned buttons width
			var widthNew = clone.width();
			//An finally remove it from the DOM.
			clone.remove();

			//And now for the animation..
			//set the current width on the button
			button.css("width", widthOld);
			//set the new text
            //button.text(text);
            buttonText.text(text);

            let animSpeed = 0;
			//Find animation speed
			if (widthNew > widthOld) {
				animSpeed = widthNew / widthOld * 100;
			} else {
				animSpeed = widthOld / widthNew * 100;
			}

			//Animate the button width
			button.css("white-space", "nowrap").animate({ width: widthNew + "px" }, animSpeed, function () {
				//and in the callback set the button width to auto
				button.css({
					"width": "auto",
					"white-space": "normal"
				});
			});

			populateDropDown(index, id, form);
			hideLists();
			resetButtonsAndLists(parseInt(index + 1), form);

			$(".nlf-button").attr("aria-expanded", "false");


			ctaButton.attr("href", url);

			if (dataTarget === "true" || dataTarget === true) {
				ctaButton.attr("target", "_blank");
			}

		});

		$(document).on("click", function (event) {
			if ($(event.target).closest(".nlf-span").length === 0) {

				hideLists();
				$(".nlf-button").attr("aria-expanded", "false");

			}
		});

	}

	init();

})(jQuery);